module.exports = __webpack_public_path__ + "img/kharkivoblenergo.018b77b7.png";